import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function ElPalo() {
  return <NeighborhoodPageContent slug="el-palo" />;
}